export default {
  metaDescription: 'PT Tokki Engineering and Fabrication(TEF)の最新ニュース、プロジェクト情報、業界インサイトをご覧いただけます。',
  pageTitle: 'ニュース・ブログ',
  readMore: '続きを読む',
  byAdmin: '管理者による投稿',
  empty: '現在、ニュースやブログ記事はありません。',
};
